/**
 * Configuration des cookies
 * Conforme RGPD et CDC Juridique v1.2 §9.6
 */

export const COOKIE_CONSENT_KEY = 'risk-data-cookie-consent'

export interface CookieCategory {
  name: string
  description: string
  required: boolean
}

export const cookieCategories: Record<string, CookieCategory> = {
  essential: {
    name: 'Essentiels',
    description: 'Necessaires au fonctionnement du site (authentification, securite)',
    required: true,
  },
  analytics: {
    name: 'Analytiques',
    description: 'Nous aident a comprendre comment vous utilisez le site',
    required: false,
  },
  functional: {
    name: 'Fonctionnels',
    description: 'Memorisent vos preferences',
    required: false,
  },
}

export interface CookieConsent {
  essential: true // Toujours true (non desactivable)
  analytics: boolean
  functional: boolean
  timestamp: number // Date du consentement
}

/**
 * Consentement par defaut (tout refuse sauf essentiels)
 */
export const defaultConsent: CookieConsent = {
  essential: true,
  analytics: false,
  functional: false,
  timestamp: 0,
}

/**
 * Consentement complet (tout accepte)
 */
export const fullConsent: CookieConsent = {
  essential: true,
  analytics: true,
  functional: true,
  timestamp: Date.now(),
}
